import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-school-timing',
  templateUrl: './school-timing.component.html',
  styleUrls: ['./school-timing.component.scss']
})
export class SchoolTimingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
